import { PAYMENT_TYPE, PAYMENT_STATUS, LOCKING_BANK_TRANSFER_REQUEST_STATUSES } from '@arbitrip/constants';

import { getBankTransferDeadline, isBankTransferAvailable } from '@/utils/PayLater';

export const SELECTION_INELIGIBILITY_REASON = {
	NOT_PAY_LATER: 'NOT_PAY_LATER',
	ALREADY_PAID: 'ALREADY_PAID',
	OPEN_BANK_TRANSFER_REQUEST: 'OPEN_BANK_TRANSFER_REQUEST',
	PAST_DEADLINE: 'PAST_DEADLINE',
};

const ELIGIBILITY_TOOLTIP_TRANSLATION_KEY = {
	[SELECTION_INELIGIBILITY_REASON.NOT_PAY_LATER]: 'Bookings.SelectToPay.Ineligible.NotPayLater',
	[SELECTION_INELIGIBILITY_REASON.ALREADY_PAID]: 'Bookings.SelectToPay.Ineligible.AlreadyPaid',
	[SELECTION_INELIGIBILITY_REASON.OPEN_BANK_TRANSFER_REQUEST]: 'Bookings.SelectToPay.Ineligible.OpenBankTransferRequest',
	[SELECTION_INELIGIBILITY_REASON.PAST_DEADLINE]: 'Bookings.SelectToPay.Ineligible.PastDeadline',
};

export const getBookingSelectionEligibility = (profile, booking) => {
	if (booking?.payment?.payment_type !== PAYMENT_TYPE.PAY_LATER) {
		return { eligible: false, reason: SELECTION_INELIGIBILITY_REASON.NOT_PAY_LATER };
	}

	if (booking?.payment?.status === PAYMENT_STATUS.BILLED) {
		return { eligible: false, reason: SELECTION_INELIGIBILITY_REASON.ALREADY_PAID };
	}

	if (LOCKING_BANK_TRANSFER_REQUEST_STATUSES.includes(booking?.bank_transfer_request?.status)) {
		return { eligible: false, reason: SELECTION_INELIGIBILITY_REASON.OPEN_BANK_TRANSFER_REQUEST };
	}

	if (!isBankTransferAvailable(profile, booking)) {
		return { eligible: false, reason: SELECTION_INELIGIBILITY_REASON.PAST_DEADLINE };
	}

	return { eligible: true, reason: null };
};

export const getSelectableBookings = (profile, bookings) =>
	(bookings || []).filter((booking) => getBookingSelectionEligibility(profile, booking).eligible);

export const getEligibilityTooltipKey = (reason) => ELIGIBILITY_TOOLTIP_TRANSLATION_KEY[reason] || '';

export const getBookingBankTransferDeadline = (booking) => getBankTransferDeadline(booking);
